import React from 'react';

export const StepAssistedSend = ({ shop, owner }) => (
  <>
    <h3 className="admin-info-header">Send handover</h3>
    <div className="sub" style={{ color: 'var(--mute)', margin: '4px 0 14px' }}>
      Clicking Send creates the shop + owner account and emails the credentials to <b>{owner.email || '—'}</b>. Booking SMS notifications for customers are enabled per shop from the master-admin Dashboard.
    </div>
    <div className="cred-box" data-testid="wiz-assisted-shop">
      <b>Shop</b><br />
      {shop.name} · {shop.subdomain}.instacut.co.uk · Plan: {shop.plan} ({shop.interval})
    </div>
    <div className="cred-box" data-testid="wiz-assisted-owner">
      <b>Owner</b><br />
      {owner.name} · {owner.email}{owner.phone ? ` · ${owner.phone}` : ''}
    </div>
    <div style={{ color: 'var(--text-mute-2)', fontSize: 'var(--fs-sm)', marginTop: 8 }}>
      The owner will sign in with the temporary password and land in the <code>/welcome</code> wizard to finish setup.
    </div>
  </>
);

export const StepReview = ({ shop, owner, barbers, services }) => (
  <>
    <h3 className="admin-info-header">Review</h3>
    <div className="sub" style={{ color: 'var(--mute)', margin: '4px 0 14px' }}>
      Click &quot;Finish onboarding&quot; to create everything in one shot. Nothing is sent — you&apos;ll see the credentials next.
    </div>
    <div className="cred-box" data-testid="wiz-review-shop">
      <b>Shop</b><br />
      {shop.name} · {shop.subdomain}.instacut.co.uk · Plan: {shop.plan} ({shop.interval})
    </div>
    <div className="cred-box" data-testid="wiz-review-owner">
      <b>Owner</b><br />
      {owner.name} · {owner.email}
    </div>
    <div className="cred-box" data-testid="wiz-review-barbers">
      <b>Barbers ({barbers.length})</b>
      {barbers.length === 0 && <div>None</div>}
      {barbers.map((b, i) => (
        <div key={i}>· {b.name}{b.role ? ` (${b.role})` : ''}{b.giveLogin ? ` — login: ${b.email}` : ''}</div>
      ))}
    </div>
    <div className="cred-box" data-testid="wiz-review-services">
      <b>Services ({services.length})</b>
      {services.length === 0 && <div>None</div>}
      {services.map((s, i) => (
        <div key={i}>· {s.name} — {s.duration_min} min — £{Number(s.price).toFixed(2)}</div>
      ))}
    </div>
  </>
);
